/** 个人中心 */
export const user_routes = [
  {
    path: "user",
    name: "user",
    meta: { jurisdiction: 1, type: "user" },
    component: () => import("@/pages/user/userCenter.vue"),
    redirect: "/user/inventory",
    children: [
      /** 我的库存 */
      {
        path: "inventory",
        name: "inventory",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/inventory/inventory.vue"),
      },
      /** 钱包明细 */
      {
        path: "wallet",
        name: "wallet",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/walletHistory"),
      },
      /** 金豆明细 */
      {
        path: "coin1",
        name: "coin1",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/coin1"),
      },
      /** 红包明细 */
      {
        path: "redPacket",
        name: "redPacket",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/redPacket"),
      },
      /** 勋章明细 */
      {
        path: "badgeList",
        name: "badgeList",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/badgeList"),
      },
      /** 开箱记录 */
      {
        path: "caseHistory",
        name: "caseHistory",
        meta: { jurisdiction: 1, type: "user", featureKey: "case_history" },
        component: () => import("@/pages/user/caseHistory/index.vue"),
      },
      /** 盒战记录 */
      {
        path: "boxBattleHistory",
        name: "boxBattleHistory",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/boxBattleHistory/index.vue"),
      },
      /** 充值明细 */
      {
        path: "rechargeHistory",
        name: "rechargeHistory",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/rechargeHistory"),
      },
      /** 提取USDT */
      {
        path: "usdtWithdraw",
        name: "usdtWithdraw",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/usdtWithdraw"),
      },
      /** 佣金记录 */
      {
        path: "commission",
        name: "commission",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/commission"),
      },
      /** hld记录 */
      {
        path: "hld",
        name: "hld",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/hld"),
      },
      /** 取回历史 */
      {
        path: "getbackList",
        name: "getbackList",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/getbackList"),
      },
      /** 副號提取紀錄 */
      {
        path: "getsubbackList",
        name: "getSubBackList",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/getSubBackList"),
      },
      /** 排行活动 */
      {
        path: "ranks",
        name: "ranks",
        meta: { jurisdiction: 0, type: "home", featureKey: "rank" },
        component: () => import("@/pages/rank/rank.vue"),
        children: [
          /** 历史排行 */
          {
            path: "rank/his",
            name: "rankHis",
            meta: { jurisdiction: 0, type: "home", featureKey: "rank" },
            component: () => import("@/pages/rank/history.vue"),
          },
          /** 排行 */
          {
            path: "rank",
            name: "rank",
            meta: { jurisdiction: 0, type: "home", featureKey: "rank" },
            component: () => import("@/pages/rank/index.vue"),
          },
        ],
      },
      /** 个人中心 */
      {
        path: "userInfo",
        name: "userinfo",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/userInfo"),
      },
      /** 推广中心 */
      {
        path: "partner",
        name: "partner",
        meta: { jurisdiction: 1, type: "user" },
        component: () => import("@/pages/user/partner/partner.vue"),
      },
      /** 推广赚金币 */
      // {
      //   path: "invite",
      //   name: "invite",
      //   meta: { jurisdiction: 1, type: "user" },
      //   component: () => import("@/pages/user/invite"),
      // },
    ],
  },
];
